// extracted by mini-css-extract-plugin
module.exports = {"HowItWorks":"_2-bE21lCyB4ORML5h_VVVe","paragraph":"ehs5N4xXTDJTnRwJBGIey","schema":"_19coNuhAZ6QS0FqX9-I8zr","image2":"_309h5VBnKeJnSEg3fZiovy","r":"_3nx3kX1c4h5vpl54Jdj-tn"};